<template lang="pug">
.layout-default(:class='{ "white-bg": whiteBg }')
  .nav-menu-mobile(
    :class='{ show: showSideBarNav }',
    v-click-outside='navMenuOutside'
  )
    slot(name='navMobile')
  .header-main-wrapper
    .header-main
      .l-header
        Topline(v-if='$slots.headerMenu', :colorMain='menuMainColor')
          slot(slot='line', name='top')
          slot(slot='addMenu', name='headerMenu')
        .header(:class='{ header_hide: isProfile }')
          .header__item(:class='headerHeigth')
            .nav-menu-mobile-bar(@click='menuToggle')
            slot(name='header')
        .popup(v-if='$slots.popup')
          .inner
            slot(name='popup')
      .wrapper(:class='[wrapperPadding, { wrapper_show: isProfile }]')
        .bg-wrapper(
          :class='[{ "bg-wrapper_padding": isProfile }, { "dark-bg": darkMenu }]',
          :style='navWrapperStyle'
        )
          markup-wrapper
            slot(name='nav')
  main.content(:class='{ content_nopadding: isProfile }')
    slot
  footer.footer
    .footer__content
      markup-wrapper
        footer-markup(:name='portalName', :logo='logoImage')
          slot(slot='alias', name='footer-alias')
          slot(slot='menu', name='footer-menu')
          slot(slot='info', name='footer-info')
          div(slot='phones')
            div(v-for='(phone, index) in footerPhonesList', :key='index')
              ext-phone(v-if='!!phone', :phone='phone')
          div(slot='emails')
            div(v-for='(email, index) in footerEmailsList', :key='index')
              footer-email(:value='email')
          slot(slot='counter', name='counter')
          .social_networks-box(slot='socialNetworks')
            a.d-flex.align-items-center(:href='socialNetworks.telegram_url')
              AppSvgIcon.ui_color__black.me-2(
                v-if='socialNetworks.telegram_url',
                manual-width='35px',
                manual-height='35px',
                color-mode='fill',
                :template='$ui.IconSvgComponents.telegram'
              )
            a.d-flex.align-items-center(:href='socialNetworks.vk_url')
              AppSvgIcon.ui_color__black.me-2(
                v-if='socialNetworks.vk_url',
                manual-width='35px',
                manual-height='35px',
                color-mode='fill',
                :template='$ui.IconSvgComponents.vk'
              )
            a.d-flex.align-items-center(:href='socialNetworks.rutube_url')
              AppSvgIcon.ui_color__black.me-2(
                v-if='socialNetworks.rutube_url',
                manual-width='35px',
                manual-height='35px',
                color-mode='fill',
                :template='$ui.IconSvgComponents.rutube'
              )
            a.d-flex.align-items-center(:href='socialNetworks.dzen_url')
              AppSvgIcon.ui_color__black.me-2(
                v-if='socialNetworks.dzen_url',
                manual-width='35px',
                manual-height='35px',
                color-mode='fill',
                :template='$ui.IconSvgComponents.dzen'
              )
            a.d-flex.align-items-center(:href='socialNetworks.ok_url')
              AppSvgIcon.ui_color__black.me-2(
                v-if='socialNetworks.ok_url',
                manual-width='35px',
                manual-height='35px',
                color-mode='fill',
                :template='$ui.IconSvgComponents.odnoklassniki'
              )
    .footer__partners(v-if='$slots.partners')
      markup-wrapper
        slot(name='partners')
    .footer__coordinators(v-if='coordinatorsImages')
      CoordinatorsBox(:items='coordinatorsImages')
  .confirm(v-if='$slots.confirm || $slots.cookie')
    .confirm__wrapper
      slot(name='cookie')
      slot(name='confirm')
  scroll-top.scroll-top
  .layout-default__hidden
    slot(name='hidden')
  slot(name='modal')
</template>

<script>
import Topline from '@/components/topline';
import ExtPhone from '@/components/ext/Phone.vue';
import FooterMenu from '@/components/parts/nav/Footer.vue';
import FooterMarkup from '@/components/parts/footer/Markup.vue';
import ScrollTop from '@/components/parts/scrolltop';
import TransitionFade from '@/components/transition/Fade.vue';
import FooterEmail from '@/components/parts/footer/Email.vue';

import { Wrapper as MarkupWrapper } from '@/components/markup';

import checkMobile from '@/mixins/checkMobile';
import isMainPageMixin from '@/mixins/isMainPage';
import isPfdodeMixin from '@/mixins/isPfdodCheck';
import colorMainMenu from '@/mixins/colorMainMenu';
import isProfile from '@/mixins/isProfile';
import CoordinatorsBox from '@/components/parts/footer/coordinators';
import AppSvgIcon from '@/uikit/components/AppSvgIconNew';

export default {
  components: {
    AppSvgIcon,
    Topline,
    ExtPhone,
    FooterMenu,
    FooterMarkup,
    FooterEmail,
    ScrollTop,
    TransitionFade,
    MarkupWrapper,
    CoordinatorsBox,
  },

  mixins: [
    checkMobile,
    isMainPageMixin,
    isPfdodeMixin,
    colorMainMenu,
    isProfile,
  ],

  props: {
    portalName: {
      type: String,
      default: '',
    },

    logoImage: {
      type: String,
      default: '',
    },

    footerEmails: {
      type: [String, Array],
      default: '',
    },

    footerPhones: {
      type: [String, Number, Array],
      default: '',
    },

    footerMenu: {
      type: Array,
      default: () => [],
    },

    footerAlias: {
      type: Array,
      default: () => [],
    },

    breadCrumbs: {
      type: Array,
      default: () => [],
    },

    darkMenu: {
      type: Boolean,
      default: false,
    },

    whiteBg: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    showSideBarNav: false,
  }),

  computed: {
    socialNetworks() {
      return this.$store.state.defaultLayout.dataSet.contacts || {};
    },

    coordinatorsImages() {
      return this.$store.state.regionProfile.footerImages &&
        this.$store.state.regionProfile.footerImages.length > 0
        ? this.$store.state.regionProfile.footerImages
        : null;
    },

    footerPhonesList() {
      const { footerPhones } = this;
      return this.dataToArray(footerPhones);
    },

    footerEmailsList() {
      const { footerEmails } = this;
      return this.dataToArray(footerEmails);
    },

    navWrapperStyle() {
      const { darkMenu, mainMenuStyle } = this;
      return darkMenu ? mainMenuStyle : false;
    },

    isHeaderMenuOnMainPage() {
      return this.$slots.headerMenu && this.isMainPage;
    },

    wrapperPadding() {
      const { isMainPage, isHeaderMenuOnMainPage, isPfdodModule } = this;
      const { top, headerMenu } = this.$slots;
      if (isHeaderMenuOnMainPage && !top) return 'wrapper_middle-padding';
      if (isHeaderMenuOnMainPage) return 'wrapper_big-padding';
      if (headerMenu && !isMainPage && isPfdodModule) return 'wrapper_padding';
      return 'wrapper_padding';
    },

    headerHeigth() {
      if (this.isHeaderMenuOnMainPage || this.isPfdodModule)
        return 'header__item_higher';
      return '';
    },
  },

  watch: {
    'checkMobile.windowWidth'() {
      this.showSideBarNav = false;
    },

    $route() {
      this.showSideBarNav = false;
    },
  },

  methods: {
    menuToggle() {
      this.showSideBarNav = !this.showSideBarNav;
    },

    navMenuOutside($event) {
      if (
        !$event.target.closest('.nav-list') &&
        $event.target.className !== 'nav-menu-mobile-bar' &&
        $event.target.className !== 'nav-item-link-text'
      ) {
        this.showSideBarNav = false;
      }
    },

    dataToArray(data) {
      return Array.isArray(data)
        ? data
        : Number.isInteger(data)
        ? data.toString().split(' ')
        : data.split(', ');
    },
  },
};
</script>

<style lang="stylus">
@media only screen and (max-height: 36.875em)
  body[data-modal]
    overflow-y hidden

  a
    color #0085ff

    &:hover
      color #51acff
      cursor pointer
</style>

<style lang="scss" scoped>
.layout-default {
  $headerHeight: 60px;
  $headerHeightHigher: 84px;
  $maxWidth: 1130px;
  $paddingSmallScreen: 0 20px 0;
  $paddingBigScreen: 0 40px 0;

  %blocksetup {
    margin-left: auto;
    margin-right: auto;
    padding: $paddingSmallScreen;
    max-width: $maxWidth;

    @media only screen and (min-width: 980px) {
      padding: $paddingBigScreen;
    }
  }

  .header {
    &__item {
      @extend %blocksetup;

      &_higher {
        height: $headerHeightHigher;
      }
    }
  }

  .popup {
    width: 100%;
    z-index: 4;
    display: block;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.25);
    background-color: #ededed;
    max-height: 100%;
    overflow-y: auto;

    .inner {
      @extend %blocksetup;
    }
  }
}
</style>

<style lang="stylus" scoped>
@import '~@/stylus/helpers/mediaqueriesStep'

$borderColor = #7875d0

$padding
  padding 30px 0

body[data-modal]
  .layout-default
    .content {
      //z-index 2
    }

.layout-default
  min-height 100%
  position relative
  background-color #ededed
  overflow hidden
  display flex
  flex-direction column
  flex auto

  &__hidden
    display none

  &.white-bg
    background-color #fff

  .header-main-wrapper
    position relative

  .l-header
    position fixed
    left 0
    z-index 22
    width 100%
    background-color #fff

    &:before
      position absolute
      left 0
      right 0
      content ''
      background-color #fff
      top 0
      bottom 0

  .header
    border-bottom 5px solid #8482d3

    &_hide
      +phone()
        display none

    &__item
      background-color #fff
      position relative
      +phone()
        height auto
        padding 0 20px

      &:after,
      &:before
        content ''
        display table

  .popup
    @media only screen and (max-height: 51.2em)
      position fixed
      top 0
      z-index 10000

    & .inner
      +phone()
        padding 0 12px 0

  .wrapper
    padding-top 65px
    position relative
    z-index 21
    &_padding
      padding-top 117px
    &_middle-padding
      padding-top 141px
    &_big-padding
      padding-top 169px
    +phone()
      display none
      padding-top 104px

    &_show
      +phone()
        display block
        padding-top 0

  .bg-wrapper
    padding 0

    +desktop()
      padding 10px 0

    &_padding
      padding 8px 0

    &.dark-bg
        background-color #5a58ad

  .content
    position relative
    flex 1 0 auto
    display flex
    flex-direction column

    +phone()
      padding-top 65px

    &_nopadding
      padding 0
      align-items center

      +phone()
        padding-top 0

      @media only screen and (min-width: 980px)
        padding 0 40px

  .confirm
    padding 0 20px
    width 100%
    background-color #ffffff
    box-shadow -6px 0 36px rgba(0, 0, 0, 0.15)
    position fixed
    left 0
    bottom 0
    z-index 100

    +tablet()
      padding 0 40px

    &__wrapper
      max-width 1050px
      margin 0 auto

  .footer
    position relative
    bottom 0
    width 100%
    border-top 10px solid $borderColor
    text-align left
    background-color #ededed
    flex 0 0 auto

    &__content
      @extends $padding
      background-color #ffffff
      z-index 1
      position relative

      .social_networks-box{
        display: flex;
        padding: 6px;
        justify-content: center;
        align-content: center;

        & > a {
          cursor: pointer;
        }
      }

    &__partners
      padding 30px 0 80px
      border-top 3px solid $borderColor
      // border-bottom 20px solid $borderColor

    &__coordinators
      border-top 3px solid $borderColor
    //&__departments
    //  //padding: 30px 40px;

  .footer .wrapper:after
    clear both

  .scroll-top
    position fixed
    bottom 10px
    left 10px

  .nav-menu-mobile-bar
    display none
    +phone()
      display block
      width 20px
      height 18px
      opacity 0.8
      background url(./img/svg/menu.svg);
      cursor pointer
      position fixed
      right 20px
      top 22px
      z-index 9999

      &:before
        content ''
        position absolute
        left -10px
        right -10px
        bottom -10px
        top -10px

  .nav-menu-mobile
    display none
    +phone()
      display block
      width 80vw
      position fixed
      top 0
      bottom 0
      left -100%
      background: #fff
      z-index 9999
      transition left 300ms ease-in

      &.show
        left 0
        transition left 300ms ease-out
</style>



// WEBPACK FOOTER //
// Default.vue?7e933324